import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {FormattedMessage} from 'react-intl';
import {fullName} from 'shared/tools';

class GoalCreated extends DomainObject {
  goalTitle;

  constructor(other) {
    super();

    makeObservable(this, {
      goalTitle: observable,
      actionDescription: computed
    });

    this.merge(other);
  }

  get actionDescription() {
    return (
      <div>
        <span className='h3 medium'>
          {fullName(this.user)}
        </span>
        &nbsp;
        <span className='jumbo'>
          <FormattedMessage id='goals.created'/>
        </span>
        &nbsp;
        <span className='medium'>
          {this.goalTitle}
        </span>
      </div>
    );
  }
}

export default GoalCreated;
